module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/level-2_start-ef79035c09665140e421ec8371688e51.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/level-2_start.png
// module id = 433
// module chunks = 2